module.exports = __webpack_public_path__ + "microcontroller.f41a311f.webp";